import { Notification } from "element-ui";

const SUCCESS_CUSTOM_CLASS_NAME = "tq-notification__success";
const WARNING_CUSTOM_CLASS_NAME = "tq-notification__warning";
const INFO_CUSTOM_CLASS_NAME = "tq-notification__info";
const ERROR_CUSTOM_CLASS_NAME = "tq-notification__error";

let NotificationServiceSingleton;

class NotificationService {
  success(options) {
    Notification.success({
      ...options,
      customClass: SUCCESS_CUSTOM_CLASS_NAME
    });
  }

  warning(options) {
    Notification.warning({
      ...options,
      customClass: WARNING_CUSTOM_CLASS_NAME
    });
  }

  info(options) {
    Notification.info({ ...options, customClass: INFO_CUSTOM_CLASS_NAME });
  }

  error(options) {
    Notification.error({ ...options, customClass: ERROR_CUSTOM_CLASS_NAME });
  }
}

if (!NotificationServiceSingleton) {
  NotificationServiceSingleton = new NotificationService();
}

export default NotificationServiceSingleton;
